var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success--text",staticStyle:{"font-size":"11px","font-weight":"600"}},[_c('v-icon',{attrs:{"x-small":"","color":"success"}},[_vm._v("mdi-check")]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }